// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_e87769bd","icon":"_58a9aa05","text":"_5b5bd153","printHide":"_cc699c7f"};